import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { DATABASE_PATHS } from './paths';

/** База данных: цилиндр — общепринятая пиктограмма СУБД (PostgreSQL). */
export const DatabaseIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {DATABASE_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
